'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.factory('jAlert', function ($q, $rootScope, $document, $ionicPopup, $ionicTemplateLoader) {

    var scope = $rootScope.$new(true);

    var defaultOptions = {
      buttonType: 'button-positive'
    };

    // notify
    scope.notify = {
      loaded: false,
      visible: false,
      type: '',
      message: '',
      autoClose: true,
      hide: function hide() {
        this.visible = false;
      }
    };

    /**
     * notify
     * @param {Object} options
     */
    function notify(options) {
      options || (options = {});
      if (scope.notify.timer) {
        window.clearTimeout(scope.notify.timer);
      }
      if (!scope.notify.loaded) {
        $ionicTemplateLoader.compile({
          template: require('./notification.html'),
          appendTo: document.body,
          scope: scope
        });
        scope.notify.loaded = true;
      }
      scope.notify.type = options.type || 'info';
      scope.notify.message = options.message;
      scope.notify.visible = true;
      scope.notify.autoClose = (0, _objectType.isBoolean)(options.autoClose) ? options.autoClose : true;
      scope.notify.autoCloseDelay = (0, _objectType.isNumber)(options.autoCloseDelay) ? options.autoCloseDelay : 1500;
      if (scope.notify.autoClose) {
        scope.notify.timer = window.setTimeout(function () {
          scope.$apply(function () {
            scope.notify.visible = false;
          });
        }, scope.notify.autoCloseDelay);
      }
    }

    // toast
    scope.toast = {
      loaded: false,
      visible: false,
      message: '',
      hide: function hide() {
        this.visible = false;
      }
    };

    /**
     * toast
     * @param {Object} options
     */
    function toast(options) {
      options || (options = {});
      if (window.cordova) {
        return window.plugins.toast.show(options.message || '', options.duration || 'short', options.position || 'center');
      } else {
        if (scope.toast.timer) {
          window.clearTimeout(scope.toast.timer);
        }
        if (!scope.toast.loaded) {
          $ionicTemplateLoader.compile({
            template: require('./toast.html'),
            appendTo: document.body,
            scope: scope
          });
          scope.toast.loaded = true;
        }
        scope.toast.message = options.message;
        scope.toast.visible = true;
        scope.toast.autoClose = (0, _objectType.isBoolean)(options.autoClose) ? options.autoClose : false;
        scope.toast.autoCloseDelay = (0, _objectType.isNumber)(options.autoCloseDelay) ? options.autoCloseDelay : 1000;
        if (scope.toast.autoClose) {
          scope.toast.timer = window.setTimeout(function () {
            scope.$apply(function () {
              scope.toast.visible = false;
            });
          }, scope.toast.autoCloseDelay);
        }
      }
    }

    return {
      notify: notify,
      toast: toast,
      showOnce: function showOnce(options) {
        options.autoClose = true;
        toast(options);
      },
      show: function show(options) {
        options || (options = {});
        return $ionicPopup.show({
          title: options.title || '提示',
          template: options.message,
          buttons: options.buttons
        });
      },
      alert: function alert(options) {
        options || (options = {});
        return $ionicPopup.alert({
          title: options.title || '提示',
          template: options.message,
          okText: '确认', // String (默认: 'OK')。OK按钮的文字。
          okType: defaultOptions.buttonType // String (默认: 'button-positive')。OK按钮的类型。
        });
      },
      confirm: function confirm(options) {
        options || (options = {});
        return $ionicPopup.confirm({
          title: options.title || '提示',
          template: options.message,
          cancelText: options.cancelText || '取消', // String (默认: 'Cancel')。一个取消按钮的文字。
          cancelType: options.cancelType || 'button-stable', // String (默认: 'button-default')。取消按钮的类型。
          okText: options.okText || '确认', // String (默认: 'OK')。OK按钮的文字。
          okType: options.okType || defaultOptions.buttonType // String (默认: 'button-positive')。OK按钮的类型。
        });
      },
      prompt: function prompt(options) {
        options || (options = {});
        if (window.cordova) {
          $cordovaDialogs.prompt(options.message, options.title || '提示', options.buttonArray || ['确定', '取消'], options.defaultText).then(function (input, buttonIndex) {
            options.callback && options.callback(input, buttonIndex);
          });
        } else {
          var res = window.prompt(options.message, options.defaultText || '');
          options.callback && options.callback(res != null ? res : '', res != null ? 1 : 2);
        }
      }
    };
  });

  return app;
};

require('angular');

require('ionic');

var _objectType = require('../../../utils/objectType');

require('./notification.scss');

require('./toast.scss');

/**
 * Loading
 * constant 返回键 处理优先级 不覆盖ionic预定义好的模块
 */

;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ionic1.x-common/services/alert/index.js
// module id = 157
// module chunks = 0